// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__JOJVR","label":"Labeled_label__azcSF","divider":"Labeled_divider__3ETDJ"};